module.exports = __webpack_public_path__ + "static/media/slider_img2.a2f244f6.jpg";